import styled from 'styled-components';
import { Layouts } from '~/shared';

export const AnimationWrapper = styled.div`
	&.${Layouts.Tablet}-enter {
		.${Layouts.Tablet}-background {
			opacity: 0;
		}

		.${Layouts.Tablet} {
			transform: translateY(200%);
		}
	}

	&.${Layouts.Tablet}-enter-active,
		&.${Layouts.Tablet}-enter-done,
		&.${Layouts.Tablet}-exit {
		.${Layouts.Tablet}-background {
			opacity: 0.25;
		}

		.${Layouts.Tablet} {
			transform: translateY(0);
		}
	}

	&.${Layouts.Tablet}-exit-active {
		.${Layouts.Tablet}-background {
			opacity: 0;
		}

		.${Layouts.Tablet} {
			transform: translateY(200%);
		}
	}
`;
